import z from 'zod'
import { decimalSchema } from '../../utils/schema'

export const balanceResponseSchema = z.object({
  /** 残高（net equity、含み損益込み） */
  balance: decimalSchema,
})

export type BalanceResponse = z.infer<typeof balanceResponseSchema>
